import React from 'react';

export default class Pagina2 extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (<h1>Pagina 2</h1>);
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/pages/Pagina2.jsx
 **/